import { render, staticRenderFns } from "./MyUpcomingExpeditionsModule.vue?vue&type=template&id=f7a788c6&"
import script from "./MyUpcomingExpeditionsModule.ts?vue&type=script&lang=ts&"
export * from "./MyUpcomingExpeditionsModule.ts?vue&type=script&lang=ts&"
import style0 from "./MyUpcomingExpeditionsModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports